import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {enableUniqueIds} from '@cred/shared/unique-id'
import {Field} from 'redux-form'
import Font from '@cred/react-font'
import {Analytics} from '@cred/react-analytics'
import { emitOnChange } from '@cred/react-analytics/hoc'
import styles from './styles.module.scss'

class Checkbox extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    mobileLabel: PropTypes.string,
    disableFullWidth: PropTypes.bool,
  }

  static defaultProps = {
    disableFullWidth: false,
  }

  constructor(props) {
    super(props)
    enableUniqueIds(this)
    this.analytics = new Analytics(props.analytics)
  }

  render() {
    const {id, className, disableFullWidth, ...props} = this.props,
      classes = [styles.checkbox, className, !disableFullWidth ? styles.fullWidth : ''].join(' ')

    return (
      <div className={classes}>
        <Field type="checkbox" component={checkboxInput} id={id || this.nextUniqueId()} styles={styles} {...props}/>
      </div>
    )
  }
}

const checkboxInput = emitOnChange(field =>
  <div>
    <input type="checkbox" id={field.id} {...field.input}/>
    <Font element="label" htmlFor={field.id}>
      <span className={field.styles.checkboxBox}>
        <span className={field.styles.checkboxIcon}>
          <i className="cred-icon icon-check"/>
        </span>
      </span>
      <span className={[field.styles.checkboxLabel, 'hidden-xs', 'hidden-sm'].join(' ')}>{field.label}</span>
      <span className={[field.styles.checkboxLabel, 'hidden-md', 'hidden-lg', 'hidden-xl'].join(' ')}>{field.mobileLabel || field.label}</span>
    </Font>
  </div>
)

export {Checkbox}
